import { useTranslation } from "react-i18next";
import {
  TrendUp,
  ChatsCircle,
  DoorOpen,
  Rocket,
  Check,
} from "@phosphor-icons/react";

export const Services = () => {
  const { t } = useTranslation();

  const groups = [
    {
      icon: TrendUp,
      title: t("gestion.services.g1_title"),
      subtitle: t("gestion.services.g1_subtitle"),
      items: t("gestion.services.g1_items", { returnObjects: true }),
    },
    {
      icon: ChatsCircle,
      title: t("gestion.services.g2_title"),
      subtitle: t("gestion.services.g2_subtitle"),
      items: t("gestion.services.g2_items", { returnObjects: true }),
    },
    {
      icon: DoorOpen,
      title: t("gestion.services.g3_title"),
      subtitle: t("gestion.services.g3_subtitle"),
      items: t("gestion.services.g3_items", { returnObjects: true }),
    },
    {
      icon: Rocket,
      title: t("gestion.services.g4_title"),
      subtitle: t("gestion.services.g4_subtitle"),
      items: t("gestion.services.g4_items", { returnObjects: true }),
    },
  ];

  return (
    <section
      data-testid="gestion-services"
      className="py-24 md:py-32 bg-slate-50 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            {t("gestion.services.kicker")}
          </p>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-bold tracking-tight text-slate-900 leading-[1.05]">
            {t("gestion.services.title")}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            {t("gestion.services.subtitle")}
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {groups.map((g, i) => {
            const Icon = g.icon;
            return (
              <article
                key={i}
                data-testid={`service-group-${i}`}
                className="rounded-3xl border border-slate-200 bg-white p-8 md:p-10 flex flex-col"
              >
                <div className="flex items-start gap-5">
                  <div className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl adonis-gradient shadow-lg shadow-[#7B61FF]/25">
                    <Icon size={26} weight="light" className="text-white" />
                  </div>
                  <div>
                    <h3 className="font-heading text-2xl md:text-3xl font-bold tracking-tight text-slate-900 leading-tight">
                      {g.title}
                    </h3>
                    <p className="mt-2 text-sm font-medium text-slate-500">
                      {g.subtitle}
                    </p>
                  </div>
                </div>

                <ul className="mt-8 space-y-4 flex-1">
                  {g.items.map((item, j) => (
                    <li
                      key={j}
                      data-testid={`service-${i}-item-${j}`}
                      className="flex items-start gap-3 text-sm md:text-base leading-relaxed text-slate-700"
                    >
                      <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full adonis-gradient">
                        <Check size={12} weight="bold" className="text-white" />
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
